export default "__VITE_PUBLIC_ASSET__b54a028e__"